export var UmbrellaOrganization;
(function (UmbrellaOrganization) {
    UmbrellaOrganization["ChiroNationaal"] = "ChiroNationaal";
    UmbrellaOrganization["ScoutsEnGidsenVlaanderen"] = "ScoutsEnGidsenVlaanderen";
    UmbrellaOrganization["KSA"] = "KSA";
    UmbrellaOrganization["KLJ"] = "KLJ";
    UmbrellaOrganization["FOS"] = "FOSOpenScouting";
    UmbrellaOrganization["JeugdRodeKruis"] = "JeugdRodeKruis";
    UmbrellaOrganization["JNM"] = "JNM";
    UmbrellaOrganization["Other"] = "Other";
})(UmbrellaOrganization || (UmbrellaOrganization = {}));
export class UmbrellaOrganizationHelper {
    static getName(umbrellaOrganization) {
        switch (umbrellaOrganization) {
            case UmbrellaOrganization.ChiroNationaal: return $t(`%nk`);
            case UmbrellaOrganization.ScoutsEnGidsenVlaanderen: return $t(`%nl`);
            case UmbrellaOrganization.KSA: return $t(`%1s`);
            case UmbrellaOrganization.KLJ: return $t(`%z`);
            case UmbrellaOrganization.FOS: return $t(`%1R`);
            case UmbrellaOrganization.JeugdRodeKruis: return $t(`%nm`);
            case UmbrellaOrganization.JNM: return $t(`%y`);
            case UmbrellaOrganization.Other: return $t(`%nn`);
        }
    }
    static getList() {
        const list = Object.values(UmbrellaOrganization);
        const ob = [];
        for (const item of list) {
            ob.push({
                name: this.getName(item),
                value: item,
            });
        }
        return ob;
    }
}
//# sourceMappingURL=UmbrellaOrganization.js.map